var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMenuNotification = function SvgMenuNotification(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9a7 7 0 1 1 14 0v3.757a2.5 2.5 0 0 0 .732 1.768l1.32 1.32c.607.607.948 1.43.948 2.288A1.867 1.867 0 0 1 20.133 20H15.86l-.093.28a3.978 3.978 0 0 1-7.572-.076L8.132 20H3.867A1.867 1.867 0 0 1 2 18.133c0-.858.34-1.68.947-2.287l1.32-1.32A2.5 2.5 0 0 0 5 12.756V9Zm4.18 11a2.978 2.978 0 0 0 5.626 0H9.181ZM12 3a6 6 0 0 0-6 6v3.757a3.5 3.5 0 0 1-1.025 2.475l-1.32 1.32c-.42.42-.655.988-.655 1.58 0 .48.388.868.867.868h16.266a.867.867 0 0 0 .867-.867c0-.593-.235-1.161-.654-1.58l-1.32-1.32A3.5 3.5 0 0 1 18 12.756V9a6 6 0 0 0-6-6Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "39ab581983b27ae9eb47984b418f5020.svg";